import styled from "@emotion/styled"
import { Colors } from "../../../../../colors"
import { Grid } from "@mui/material"


export const SearchTabReservationStyled = {
    ContainerSearch: styled(Grid)<any>`
        display: flex;
        align-items: center;
        margin-top: 20px;
        border-bottom: 2px solid ${Colors.UnderlinedGrey};
        background-color: ${Colors.LightGrey};
        padding: 10px 30px 0 30px;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
    `,
    ContainerEditSearch: styled(Grid)<any>`
        width: 40%;
    `,
    ContainerIconSearch: styled(Grid)<any>`
    `,
}